export default __webpack_public_path__ + "images/UA.f37ef76.png";